// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + "app" + ".bundle." + "14ed42ba438a9e12b1eb" + ".css";
};